import { render, staticRenderFns } from "./TarifaColacion.vue?vue&type=template&id=2ed7d7a7&"
import script from "./TarifaColacion.vue?vue&type=script&lang=js&"
export * from "./TarifaColacion.vue?vue&type=script&lang=js&"
import style0 from "./TarifaColacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports